import { render, staticRenderFns } from "./ParentsBulletinBoard.vue?vue&type=template&id=78a454c2&scoped=true&"
import script from "./ParentsBulletinBoard.vue?vue&type=script&lang=js&"
export * from "./ParentsBulletinBoard.vue?vue&type=script&lang=js&"
import style0 from "./ParentsBulletinBoard.vue?vue&type=style&index=0&id=78a454c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78a454c2",
  null
  
)

export default component.exports